import { getStoreConfig } from 'config'

export const parseUrlPathName = (relativeUrl: string): string => {
    const config = getStoreConfig()
    const {
        seo: { multiStoreUrlParamCount }
    } = config

    const multiStoreUrlCount = multiStoreUrlParamCount || 0

    // Trim slashes
    relativeUrl = relativeUrl.replace(/^\/|\/$/g, '')
    if (relativeUrl === '') {
        return relativeUrl
    }
    // Remove url params
    const matches = relativeUrl.match(/^([^?]*)(\?.*)?$/)
    const matchedUrl = matches && matches.length > 1 ? matches[1] : relativeUrl

    if (multiStoreUrlCount > 0) {
        const newPathPath = matchedUrl.split('/')
        newPathPath.splice(0, multiStoreUrlParamCount)
        return newPathPath.join('/')
    } else {
        return matchedUrl
    }
}
